import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { LinkButton } from "@perfectserve/library";
export const PlatformComparison = ({ showPlatformData, platformLoading, platformFinalActionsData, onHidePlatformData, }) => {
    if (!showPlatformData) {
        return null;
    }
    return (_jsxs("div", { children: [_jsxs("div", { className: "d-flex justify-content-between align-items-center mb-15", children: [_jsxs("h3", { className: "m-0 fs-16 fw-600 text-gray-800", children: ["Platform Overview", _jsx("span", { className: "fs-12 fw-400 text-muted ml-10", children: "(Previous Week)" })] }), _jsx(LinkButton, { onClick: onHidePlatformData, className: "fs-12", children: "Hide what happened on the platform" })] }), platformLoading ? (_jsx("div", { className: "d-flex align-items-center justify-content-center bg-gray-100 text-muted fs-14 rounded-8", style: { height: "60px" }, children: "Loading platform data..." })) : platformFinalActionsData.length > 0 ? (_jsxs(_Fragment, { children: [_jsx("div", { className: "d-flex bg-gray-100 rounded-8 overflow-hidden border border-gray-300", style: {
                            height: "60px",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                        }, children: platformFinalActionsData.map((action, index) => (_jsx("div", { style: {
                                width: `${Math.max(action.percentage, 0.5)}%`,
                                minWidth: action.percentage < 1 ? "8px" : "auto",
                                backgroundColor: action.color,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "white",
                                fontSize: "14px",
                                fontWeight: "600",
                                position: "relative",
                                borderRight: index < platformFinalActionsData.length - 1 ? "1px solid rgba(255,255,255,0.3)" : "none",
                            }, title: `${action.name}: ${action.count.toLocaleString()} (${action.percentage}%)` }, action.name))) }), _jsx("div", { style: {
                            display: "flex",
                            marginTop: "12px",
                            height: "80px",
                            alignItems: "flex-start",
                            position: "relative",
                        }, children: platformFinalActionsData.map((action, index) => {
                            var _a;
                            let leftPosition = 0;
                            for (let i = 0; i < index; i++) {
                                leftPosition += ((_a = platformFinalActionsData[i]) === null || _a === void 0 ? void 0 : _a.percentage) || 0;
                            }
                            if (action.percentage < 3)
                                return null;
                            const centerPosition = leftPosition + action.percentage / 2;
                            return (_jsx("div", { style: {
                                    position: "absolute",
                                    left: `${centerPosition}%`,
                                    transform: "translateX(-50%)",
                                    textAlign: "center",
                                    fontSize: "12px",
                                    color: "var(--ps-gray-800)",
                                    lineHeight: "1.3",
                                    whiteSpace: "nowrap",
                                    maxWidth: "120px",
                                    top: "8px",
                                }, children: _jsxs("div", { children: [_jsx("div", { style: {
                                                fontWeight: "600",
                                                marginBottom: "4px",
                                            }, children: action.name }), _jsxs("div", { style: {
                                                fontSize: "11px",
                                                color: "var(--ps-gray)",
                                            }, children: [action.count.toLocaleString(), " (", action.percentage, "%)"] })] }) }, `platform-${action.name}`));
                        }) })] })) : (_jsx("div", { style: {
                    height: "60px",
                    backgroundColor: "var(--ps-gray-100)",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "var(--ps-gray)",
                    fontSize: "14px",
                    border: "1px solid var(--ps-gray-300)",
                }, children: "No platform data available" }))] }));
};
export default PlatformComparison;
//# sourceMappingURL=PlatformComparison.js.map